import { utf8ToBytes } from '../../lib/pqc/codecs';

export const MAX_MESSAGE_BYTES = 8 * 1024;

export function formatBytes(bytes: number): string {
  return `${bytes.toLocaleString()} bytes`;
}

export function formatDuration(ms: number): string {
  return `${ms.toFixed(1)} ms`;
}

export function getMessageBytes(text: string): Uint8Array {
  return utf8ToBytes(text);
}

export function updateByteCounter(
  input: HTMLTextAreaElement | HTMLInputElement,
  output: HTMLElement,
  maxBytes: number
): number {
  const bytes = getMessageBytes(input.value);
  output.textContent = `${formatBytes(bytes.length)} (max ${formatBytes(maxBytes)})`;
  output.classList.toggle('text-rose-600', bytes.length > maxBytes);
  return bytes.length;
}

export async function copyToClipboard(value: string) {
  if (!value) return;
  if (navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(value);
    return;
  }
  const temp = document.createElement('textarea');
  temp.value = value;
  temp.style.position = 'fixed';
  temp.style.opacity = '0';
  document.body.appendChild(temp);
  temp.select();
  document.execCommand('copy');
  temp.remove();
}

export function downloadText(filename: string, text: string) {
  const blob = new Blob([text], { type: 'text/plain' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.click();
  setTimeout(() => URL.revokeObjectURL(url), 0);
}

export function setStatus(target: HTMLElement, message: string) {
  target.textContent = message;
}

export function setError(target: HTMLElement, message: string) {
  target.textContent = message;
  target.classList.toggle('hidden', message.length === 0);
}
